






























































































































































import Vue from 'vue';
import * as pazienteApi from '../../services/paziente-api';
import { PazienteEditViewModel } from '../../types';
import validationRulesMixin from '../../components/mixin/validation-rules-mixin';
import AttributoSelector from '../selectors/AttributoSelector.vue';

export default Vue.extend({
    mixins: [validationRulesMixin],

    components: { AttributoSelector },
    props: {
        fullSize: { default: false },
        id: { default: 0 },
    },
    data(): PazienteEditViewModel {
        return {
            item: null,
            isValid: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await pazienteApi.getByKey(id);
            } else {
                this.setNewItem();
            }
        },
        close() {
            this.$emit('close');
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await pazienteApi.create(this.item);
            } else {
                response = await pazienteApi.update(this.item);
            }
            await this.loadData(response.id);
            this.$emit('save', this.item);
        },
        setNewItem() {
            this.item = {
                id: 0,
                version: 0,
                nome: '',
                cognome: '',
                sessoId: 0,
                codiceFiscale: '',
                indirizzo: '',
                numeroDocumento: '',
                attivo: true,
                displayName: this.$i18n.t('labels.nuovo').toString(),
            };
        },
    },
    async mounted() {
        await this.loadData(this.id);
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
});
